import * as React from 'react';

const Notification = ({ children, type = 'primary' }) => (
  <div className={`notification is-${type}`}>{children}</div>
);

export default Notification;
